export default __webpack_public_path__ + "static/custom2-7f8d355fab39d7a1675a994c2fe48366.svg";